import * as React from 'react';
import './Menu-desktop.css';
import './Menu-mobile.css';
import {feature} from "./ToggleButton/FeatureToggle";
import {FeatureToggle} from "./ToggleButton/FeatureToggle";
import {details} from "./DetailButton/DetailToggle";
import {DetailToggle} from "./DetailButton/DetailToggle";
import { IUserAgentType, ICanvasSize } from '../../sharedInterfaces';
import {ModelControler} from "../../service/modelController";
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import {PriceService} from "../../service/PriceService";
import { Basket } from './Basket/Basket';
import { Checkout } from '../../service/Checkout';
import {Ref} from "react";
import { string } from 'prop-types';
const axios = require("axios");

interface MenuProps {
    userAgentType:IUserAgentType,
    canvasSize:ICanvasSize,
    preserveCamera:boolean,
    autoScaleUp:boolean,
    autoScaleDown:boolean,
    startMenuOn:boolean,
    setMeshVisibility:()=>void,
    playAnimation:(s:string)=>void,
    setCamera:(n:string)=>void,
    //write & execute functions in App.tsx, simply pass it as callback to Menu.tsx
    changeCanvasSize:(w:number, h:number) => void,

    goBack:() => void

}

interface MenuState {
    price:number;
    topBackgroundVisible:boolean;
}

export class Menu extends React.Component<MenuProps, MenuState> {
    grillButton:any;
    constructor(props:MenuProps) {
        super(props);
        this.state = {
            price: PriceService.instance.getSumPrice(),
            topBackgroundVisible:false
        }
        this.grillButton = React.createRef();
        details.forEach((element, index)=>{
            element.parentToggle = feature[index].name;
        })
        PriceService.instance.priceObserve.addListener('priceChange', () => this.changePriceSumDisplay());
        this.changePriceSumDisplay();
    }

    componentDidMount() {
        PriceService.instance.priceObserve.addListener('priceChange', () => this.changePriceSumDisplay());
        this.changePriceSumDisplay();
    }

    changePriceSumDisplay() {
        this.setState({price: PriceService.instance.getSumPrice()})
    }

    getMenu() {
        const userAgentType = this.props.userAgentType;
        //const productList = this.getProductList();

        switch (userAgentType) {
            case IUserAgentType.desktop:
                return (
                    <div id="menu-desktop" className={(this.props.startMenuOn ? 'hide-menu' : '')}>
                        <iframe width="0" height="0" name="dummyframe" id="dummyframe"></iframe>
                        <div id="back-to-start-wrapper">
                            <div id="back-to-start" onClick={this.props.goBack}>
                                <i className="fas fa-arrow-left"></i>
                                <span>Zurück</span>
                            </div>
                        </div>
                        <div id="header-menu">
                            <div id="price-wrapper">
                                <p id="price-text">Preis Gesamt: </p>
                                <p id="mwst-text">inkl. Mwst. + ggfs Versandkosten</p>
                                <div id="whole-price">{this.state.price? this.state.price.toFixed(2):0}€</div>
                            </div>
                            <div id="to-cart">
                                    <button name="In den Warenkorb" className="fas fa-shopping-cart button-checkout fade" onClick={()=>{this.grillButton.submit()}}></button>
                            </div>
                            <div >
                                <form method="post"
                                      action="https://www.schickling-grill.de/checkout/addArticle"
                                      //target="dummyframe"
                                      ref={form => this.grillButton = form}
                                    >
                                    <input type="hidden" name="sAction" value="addArticle">
                                    </input>
                                    <input type="hidden" name="sAdd" value={ModelControler.instance.getCurrentProduct().product.getId()}>
                                    </input>
                                    <input type="hidden" name="sQuantity" value="1">
                                    </input>
                                    <input type="hidden" name="sAddAccessories" value={this.getProductForCheckOut()}>
                                    </input>
                                    <input type="hidden" name="__csrf_token"
                                           value={Checkout.instance.getCSRFToken()}>
                                    </input>
                                </form>
                            </div>
                            <Basket></Basket>
                        </div>

                        <PerfectScrollbar className='scroll-menu'>
                            <div id="detail-menu" className='scroll-menu'>
                                <div className={"button-wrapper-top " + (this.state.topBackgroundVisible ? " ":"hidden")}>
                                    {details.map((detail) => {
                                    return (
                                        <DetailToggle 
                                            ref={component => detail.ref = component} 
                                            detailID={detail.detailID} 
                                            parentToggle={detail.parentToggle} 
                                            featureName={detail.featureName} 
                                            renderVisibility={this.props.setMeshVisibility} 
                                            playAnimation={this.props.playAnimation}
                                        />
                                    )
                                 })}
                                </div>
                                <div className="button-wrapper-bottom">
                                    {feature.map((feat) => {
                                    return (
                                        //HACKY -FL
                                        <FeatureToggle 
                                            name={feat.name}
                                            featureName={feat.featureName}
                                            modelID={null} productID={null} 
                                            onClick={this.toggleCheckbox.bind(this, feat.name)}
                                            renderVisibility={this.props.setMeshVisibility} 
                                        />
                                    )
                                })}
                                </div>
                            </div>
                            
                        </PerfectScrollbar>
                    </div>
                )

            case IUserAgentType.mobile:
                return (
                    <div id="menu-mobile">
                        -- PLACEHOLDER FOR MOBILE MENU --
                    </div>
                )
        } 
    }

    getProductForCheckOut():string{
        let accesories:string = "";
        ModelControler.instance.getCurrentProduct().features.forEach((e)=>{
            if(e.getProduct()){
                accesories += e.getProduct().getId() + ";";
                
            }
        })
        return accesories;
    }

    toggleMeshGroup(name:string){
        let feature = ModelControler.instance.getFeatures().find(elem => elem.getName() === name);
        feature.toogleModel();
        this.props.setMeshVisibility();
    }

    toggleCheckbox(name:string){
        // console.log("click");
        let toogleBox = details.find(elem => elem.parentToggle === name);
        toogleBox.ref.toggleVisible()
        .then(()=>{
            this.setState({
                topBackgroundVisible:this.getCheckBoxVisibility()
            })
            // console.log("top visible: ", this.getCheckBoxVisibility());
        })
        try{
            this.props.setCamera(name);
        }
        catch(e){
            this.props.setCamera("DEFAULT_CAMERA");
        }
    }

    turnIcon() {
        var element = document.getElementById("rotate-icon");

        if (element.classList) {
            element.classList.toggle("turn-icon");
        } else {
            // For IE9
            var classes = element.className.split(" ");
            var i = classes.indexOf("turn-icon");

            if (i >= 0)
                classes.splice(i, 1);
            else
                classes.push("turn-icon");
            element.className = classes.join(" ");
        }
    }

    getCheckBoxVisibility():boolean{
        for (let detail of details) {
            if(detail.ref.getVisibility()){
                return true;
            }
        }
        return false;
    }

    testCheckOut(){
        axios.post('https://www.schickling-grill.de/checkout/addArticle/sTargetAction/cart', {
            sAdd:"01010010",
            __csrf_token:"tiJ04CPUklvdTQjEBIdVKSAzI1xM5u"
        })
    }

    render() {
        let menu;

        menu = this.getMenu();

        return (
            //UI magic here
            
            <div id="vc-3d-ui">
                {menu}
            </div>
        );
    }
}